import { render, staticRenderFns } from "./Moderation.vue?vue&type=template&id=7059560d&scoped=true&"
import script from "./Moderation.vue?vue&type=script&lang=js&"
export * from "./Moderation.vue?vue&type=script&lang=js&"
import style0 from "./Moderation.vue?vue&type=style&index=0&id=7059560d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7059560d",
  null
  
)

export default component.exports